import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FullSaleTransactionDataFragment } from '../../../../api';
import Accordion from '../../../../components/Accordion';
import HandoverForm from '../../Forms/HandoverForm';

export type HandoverTabProps = {
    saleTransaction: FullSaleTransactionDataFragment;
};

const HandoverTab = ({ saleTransaction }: HandoverTabProps) => {
    const { t } = useTranslation(['saleTransactionsPage']);

    return (
        <Grid spacing={2} container>
            <Grid xs={12} item>
                <Accordion title={t('saleTransactionsPage:accordionTitle.handover')} defaultExpanded>
                    <HandoverForm currentStage={saleTransaction.stage} />
                </Accordion>
            </Grid>
        </Grid>
    );
};

export default HandoverTab;
